import type { SortOption } from "@src/features/clips/types/camera";

export type SortOptionItem = {
  label: string;
  value: SortOption;
};

export const CAMERA_SORT_OPTIONS: SortOptionItem[] = [
  { label: "ID", value: "id" },
  { label: "Name", value: "name" },
  { label: "Site", value: "site" },
];
